const Banner1 = () => {
  return (
    <div className="w-full mb-12">
      <h2 className="relative inline-block text-[40px] font-semibold text-gray-800 after:content-[''] after:block after:w-16 after:h-[3px] after:bg-brand-500 after:rounded-full after:mt-2">
        Landing page
      </h2>
    </div>
  );
};

export default Banner1;
